@if (control(); as control) {
  @if (field(); as field) {
    <mat-form-field fxFlex color="accent">
      @if (field.label?.(); as label) {
        <mat-label [ngClass]="{ 'capitalize-first-letter': $safeNavigationMigration(field.capitalized?.()) }">{{ label | translate }}</mat-label>
      }

      <input
        class="iot-platform-ui-form-field__date-picke-input iot-platform-ui-form-field--{{ field.name?.() }} {{ field.inputCssClassName?.() }}"
        data-cy="form-control"
        matInput
        [required]="required()"
        [formControl]="control"
        [matDatepicker]="datePicker"
        [min]="field.min?.() ?? null"
        [max]="field.max?.() ?? null"
        fxFlex
        (focus)="datePicker.open()"
        (dateChange)="field.selectionChange?.($event)"
      />
      <mat-datepicker-toggle [disableRipple]="true" matIconSuffix [for]="datePicker" class="iot-platform-ui-form-field__date-picker-toggle">
        @if (field.toggleIcon?.()) {
          <mat-icon matDatepickerToggleIcon>{{ field.toggleIcon?.() }}</mat-icon>
        } @else {
          <mat-icon matDatepickerToggleIcon>today</mat-icon>
        }
      </mat-datepicker-toggle>
      <mat-datepicker #datePicker></mat-datepicker>
      @if (!field.disabled?.() && control?.getRawValue()) {
        <mat-hint class="iot-platform-ui-form-field__date-picker-clear">
          <span (click)="control?.reset(); field.onClear?.($event)">{{ field.clearLabel?.() ?? 'FILTER_ENGINE.CLEAR' | translate }}</span>
        </mat-hint>
      }

      @if (control?.invalid && control?.hasError('required')) {
        <mat-error>{{ 'FORM.ERROR_MESSAGE.REQUIRED' | translate }}</mat-error>
      } @else if (control?.invalid && control?.hasError('maxlength')) {
        <mat-error>{{
          'FORM.ERROR_MESSAGE.MAX_LENGTH' | translate: { value: $safeNavigationMigration(control.getError('maxlength')?.requiredLength) }
        }}</mat-error>
      } @else if (control?.invalid && control?.hasError('minlength')) {
        <mat-error>{{
          'FORM.ERROR_MESSAGE.MIN_LENGTH' | translate: { value: $safeNavigationMigration(control.getError('minlength')?.requiredLength) }
        }}</mat-error>
      } @else if (control?.invalid && control?.hasError('matDatepickerMax')) {
        <mat-error>{{ 'FORM.ERROR_MESSAGE.MAX' | translate: { value: $safeNavigationMigration(control.getError('matDatepickerMax')?.max) } }}</mat-error>
      } @else if (control?.invalid && control?.hasError('matDatepickerMin')) {
        <mat-error>{{ 'FORM.ERROR_MESSAGE.MIN' | translate: { value: $safeNavigationMigration(control.getError('matDatepickerMin')?.min) } }}</mat-error>
      } @else if (control?.invalid && control?.hasError('pattern')) {
        <mat-error>{{ 'FORM.ERROR_MESSAGE.PATTERN' | translate }}</mat-error>
      } @else if (control?.invalid && field.error?.enabled?.() && field.error?.message?.()) {
        <mat-error>{{ $safeNavigationMigration(field.error?.message?.()) | translate }}</mat-error>
      }

      @if (field.prefix) {
        <mat-icon
          class="prefix-icon cursor-pointer"
          [ngClass]="{ 'animate-spin': $safeNavigationMigration(field.prefix?.loading?.()), invisible: field.prefix?.visible && !field.prefix?.visible() }"
          style="margin-right: 5px"
          [matTooltip]="field.prefix?.tooltip?.() ?? '' | translate"
          matPrefix
          matTooltipClass="regular-tooltip"
          matTooltipPosition="below"
          (click)="field?.prefix?.onClick?.($event)"
          >{{ field.prefix?.icon?.() }}
        </mat-icon>
      }

      @if (field.suffix) {
        <mat-icon
          class="suffix-icon cursor-pointer"
          [ngClass]="{ 'animate-spin': $safeNavigationMigration(field.suffix?.loading?.()), invisible: field.suffix?.visible && !field.suffix?.visible() }"
          style="margin-left: 5px"
          [matTooltip]="field.suffix?.tooltip?.() ?? '' | translate"
          matSuffix
          matTooltipClass="regular-tooltip"
          matTooltipPosition="below"
          (click)="field?.suffix?.onClick?.($event)"
          >{{ field.suffix?.icon?.() }}
        </mat-icon>
      }

      @if (field.hint?.()?.type?.() === FormControlHintType.TEXT) {
        <mat-hint align="end">
          {{ $safeNavigationMigration(field.hint?.()?.text?.()) | translate }}
        </mat-hint>
      } @else if (field.hint?.()?.type?.() === FormControlHintType.TEMPLATE_REF) {
        <mat-hint align="end">
          <ng-container [ngTemplateOutlet]="$safeNavigationMigration(field.hint?.()?.templateRef?.())" />
        </mat-hint>
      }
    </mat-form-field>
  }
}
